import React from 'react';
import { SurveyQuestion } from './SurveyQuestion';

export const SurveyHeading = ({ option }) => {
    return (
        <React.Fragment>
            <SurveyQuestion option={option} />
        </React.Fragment>
    );
}